import React, { createContext, useContext } from 'react';

const TestContext = createContext('create');

export const TestContextProvider = ({
  value,
  children,
}: {
  value: string;
  children: JSX.Element;
}): JSX.Element => (
  <TestContext.Provider value={value}>{children}</TestContext.Provider>
);

export const useTestContext = (): string => useContext(TestContext);
